import { getRuntimeEnv } from "~/utils/getRuntimeEnv";

export const APP_DOMAIN = "https://predictionhero.com";
export const APP_TITLE =
  "PredictionHero | Prediction Market Odds & Probabilities";
export const APP_DESCRIPTION =
  "Compare odds and probabilities across Polymarket, Kalshi, Limitless, Predict.Fun, and Opinion. See where prediction markets agree.";
export const DEFAULT_ERROR_MESSAGE =
  "Whoops! Something went wrong. Please try again later.";

const runtimeEnv = getRuntimeEnv();

/**
 * RTK `fetchBaseQuery` uses `fetch` / `Request`, which on the server (Node/undici)
 * require an absolute URL. Relative paths like `/api` must be resolved against
 * the public site origin (`VITE_BASE_URL`).
 *
 * Викликайте на кожному запиті (через dynamic baseQuery), а не один раз при імпорті модуля.
 */
const stripTrailingSlash = (url: string) => url.replace(/\/$/, "");

const getConfiguredApiPath = (): string =>
  (
    getRuntimeEnv()?.VITE_API_BASE_URL ||
    (typeof window === "undefined" ? process.env.VITE_API_BASE_URL : "") ||
    "/api"
  ).trim();

const resolveApiBase = (apiPath: string, origin: string): string =>
  stripTrailingSlash(
    new URL(apiPath.startsWith("/") ? apiPath : `/${apiPath}`, origin).toString()
  );

export function getApiBaseUrlForFetch(): string {
  // On the server, prefer the internal cluster URL to avoid public internet
  // round-trips (Cloudflare → Traefik → core-api). This keeps SSR fast.
  if (typeof window === "undefined") {
    const ssrUrl = process.env.SSR_API_BASE_URL?.trim();
    if (ssrUrl) {
      return stripTrailingSlash(ssrUrl);
    }
  }

  const apiPath = getConfiguredApiPath();

  if (/^https?:\/\//i.test(apiPath)) {
    return stripTrailingSlash(apiPath);
  }

  if (typeof window !== "undefined") {
    return resolveApiBase(apiPath, window.location.origin);
  }

  const publicOrigin = (
    getRuntimeEnv()?.VITE_BASE_URL ||
    process.env.VITE_BASE_URL ||
    ""
  ).trim();

  if (!publicOrigin) {
    throw new Error(
      "[SSR] Cannot resolve absolute API URL: set VITE_BASE_URL (public site origin) when VITE_API_BASE_URL is a relative path (e.g. /api)."
    );
  }

  return resolveApiBase(apiPath, publicOrigin);
}

export function getPublicApiBaseUrl(siteOrigin: string): string {
  const apiPath = getConfiguredApiPath();

  return /^https?:\/\//i.test(apiPath)
    ? stripTrailingSlash(apiPath)
    : resolveApiBase(apiPath, siteOrigin);
}

export const BASE_URL =
  typeof window !== "undefined"
    ? window.location.origin
    : runtimeEnv?.VITE_BASE_URL;
export const GOOGLE_RECAPTCHA_SITE_KEY =
  runtimeEnv?.VITE_GOOGLE_RECAPTCHA_SITE_KEY || "";
export const INTERCOM_ID = runtimeEnv?.VITE_INTERCOM_ID;export const CLERK_PUBLISHABLE_KEY =
  runtimeEnv?.VITE_CLERK_PUBLISHABLE_KEY || "";
